const localeConfig: ILocalConfig = {
  order: ['products', 'resources'],
  sitemapXMLExcludedPages: [
    '/childhood-vaccinations/',
    '/fever-and-pain/',
    '/pain-and-inflammation-leaflet/',
],
};

interface ILocalConfig {
  order: string[]
  sitemapXMLExcludedPages: string[]
}

export default localeConfig;